<template>
  <div>
    <DetailSectionColumnLayout
      :itemPerColumns="[12, 12]"
      :modelData="user"
      labelKey="labelDetail"
      :listFields="$store.getters.professionalInfoFields"
      :listExcludeFields="[]"
    />
  </div>
</template>

<script>
import DetailSectionColumnLayout from "../../common/DetailSectionColumnLayout";

export default {
  components: {
    DetailSectionColumnLayout
  },
  mounted() {
    console.log(this.user);
  },
  props: ["user"],
  computed: {
    editAccess() {
      if (
        this.user.id == this.$store.getters.userID ||
        this.$store.getters.isAgent === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfessionalInfo.vue